<template>
  <div class="security-risk column">
    <span class="risk-code">{{securityRiskCode}}</span>
    <span @click="displayIssueDetailsPopup"
          :title="$pt('projectDetails.issue.securityRiskDescription', securityRiskDescription)"
          class="risk-description">
      {{$pt('projectDetails.issue.securityRiskDescription', securityRiskDescription)}}
    </span>
  </div>
</template>

<script>
import { getSecurityRiskCode, getSecurityRiskDescription } from '@/utils/stringUtils';

export default {
  name: 'IssueSecurityRiskTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    securityRiskDescription() {
      return getSecurityRiskDescription(this.item.securityRisk);
    },
    securityRiskCode() {
      return getSecurityRiskCode(this.item.securityRisk);
    },
  },
  methods: {
    async displayIssueDetailsPopup() {
      this.$emit('showIssueDetails', this.item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.security-risk {

  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(16);

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .risk-code {
    color: var(--text-tertiary);
    font-size: rem(14);
    font-weight: bold;
    letter-spacing: 0;
    line-height: rem(16);
  }

  .risk-description {
    color: var(--text-primary);
    font-size: rem(14);
    letter-spacing: 0;
    line-height: rem(16);
    text-transform: capitalize;

    &:hover {
      color: var(--brand-primary);
      cursor: pointer;
    }
  }
}
</style>
